import {
  BarChart, Bar, LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, ReferenceLine,
} from 'recharts';
import { c, card, chart } from '../../theme';
import { fmtCount, fmtPct } from './format';

// Two charts on one set of days rather than one chart with two axes: volume
// and service level share nothing but the date, and a second axis lets
// whichever scale is drawn taller look more dramatic than it is.
export default function LeadershipDailyChart({ daily, target }) {
  if (!daily.length) return null;
  const data = daily.map((d) => ({ ...d, label: d.date.slice(5).replace('-', '/') }));
  const slValues = daily.map((d) => d.serviceLevel).filter((v) => v != null);
  const slMin = slValues.length ? Math.max(0, Math.floor(Math.min(...slValues, target) / 5) * 5 - 5) : 0;
  const axis = { fontSize: 11, fill: chart.axisText };
  const tooltip = {
    contentStyle: { fontSize: 12, borderColor: chart.tooltipBorder, borderRadius: 6 },
    labelStyle: { color: c.textStrong, fontWeight: 600 },
  };

  return (
    <section style={s.card} aria-label="Daily trend">
      <h2 style={s.h2}>Handled per day</h2>
      <ResponsiveContainer width="100%" height={160}>
        <BarChart data={data} margin={{ top: 4, right: 8, bottom: 0, left: 0 }}>
          <CartesianGrid stroke={chart.grid} vertical={false} />
          <XAxis dataKey="label" tick={axis} tickLine={false} axisLine={{ stroke: chart.grid }} interval="preserveStartEnd" />
          <YAxis tick={axis} tickLine={false} axisLine={false} width={44} tickFormatter={(v) => fmtCount(v)} />
          <Tooltip {...tooltip} formatter={(v) => [fmtCount(v), 'Handled']} />
          <Bar dataKey="handled" fill={chart.emphasis} radius={[3, 3, 0, 0]} isAnimationActive={false} />
        </BarChart>
      </ResponsiveContainer>

      <h2 style={{ ...s.h2, marginTop: 14 }}>Service level per day</h2>
      <ResponsiveContainer width="100%" height={140}>
        <LineChart data={data} margin={{ top: 4, right: 8, bottom: 0, left: 0 }}>
          <CartesianGrid stroke={chart.grid} vertical={false} />
          <XAxis dataKey="label" tick={axis} tickLine={false} axisLine={{ stroke: chart.grid }} interval="preserveStartEnd" />
          <YAxis domain={[slMin, 100]} tick={axis} tickLine={false} axisLine={false} width={44} tickFormatter={(v) => `${v}%`} />
          <Tooltip {...tooltip} formatter={(v) => [fmtPct(v), 'Service level']} />
          <ReferenceLine y={target} stroke={c.successText} strokeDasharray="4 3"
            label={{ value: `Target ${target}%`, position: 'insideTopRight', fontSize: 10, fill: c.successText }} />
          <Line dataKey="serviceLevel" stroke={chart.categorical[0]} strokeWidth={2} dot={{ r: 2 }}
            connectNulls={false} isAnimationActive={false} />
        </LineChart>
      </ResponsiveContainer>
      <p style={s.foot}>Days with no calls (most Sundays) have no service level and leave a gap.</p>
    </section>
  );
}

const s = {
  card: { ...card.base, padding: '16px 18px' },
  h2:   { fontSize: '13px', fontWeight: 650, color: c.text, margin: '0 0 6px' },
  foot: { fontSize: '11px', color: c.textMuted, margin: '6px 0 0' },
};
